/* global axios */
import ApiClient from '../ApiClient';

class PilotAssistantKnowledgeBases extends ApiClient {
  constructor() {
    super('pilot/assistants', { accountScoped: true });
  }

  get({ assistantId }) {
    return axios.get(`${this.url}/${assistantId}/knowledge_bases`);
  }

  create({ assistantId, knowledgeBaseId }) {
    return axios.post(`${this.url}/${assistantId}/knowledge_bases`, {
      knowledge_base_id: knowledgeBaseId,
    });
  }

  delete({ assistantId, id }) {
    return axios.delete(`${this.url}/${assistantId}/knowledge_bases/${id}`);
  }
}

export default new PilotAssistantKnowledgeBases();
